<template>
  <div data-app>
    <group-card title="Communications" icon="comment" padded>
      <md-tabs
        md-dynamic-height
      >
        <md-tab id="audit_logs" md-label="Audit Logs">
          <AuditLogs></AuditLogs>
        </md-tab>

        <md-tab id="in_app_comments" md-label="In App Comments">
          <edit-loan-comments  ref="editComment" :style="style"
            v-model="application"
            :available-sections="availableSections"
          />
        </md-tab>


        <md-tab id="email" md-label="CUSTOMER TRAIL">
          <div class="boxed-category text-center">
            <EmailAuditLogs/>
            <CallOutcomeLogs/>
          </div>
        </md-tab>

        <md-tab id="document_request" md-label="Document Request">
          <ApplicantDocumentRequests></ApplicantDocumentRequests>
        </md-tab>

        <md-tab id="status_change_comments" md-label="Status Change Comments">
          <group-card title="Comments" icon="comment">

            <group-card-row title="Comments">
              <template v-slot:content>

                <div class="md-layout-item md-size-100" >

                  <table class="data-table">
                    <colgroup>
                      <col style="width: 200px;">
                      <col style="width: 310px;">
                    </colgroup>
                    <thead>
                    <tr>
                      <th><code>Tag</code></th>
                      <th><code>Comment</code></th>
                      <th><code>Time</code></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="comment of application.loan.comments" >
                      <template v-if="comment.tag == 'Status Comment'">
                        <td>{{ comment.tag }}</td>
                        <td>{{ comment.content }}</td>
                        <td>{{ comment.created_at }}</td>
                      </template>
                    </tr>
                    </tbody>
                  </table>

                </div>

              </template>
              <template v-slot:validation></template>
            </group-card-row>

          </group-card>
        </md-tab>

      </md-tabs>
    </group-card>
  </div>
</template>
<floating-comment-section v-model="application" :available-sections="availableSections" />
<script>
import AuditLogs from "@/pages/AuditLogs.vue";
import { GroupCard } from "@/components";
import { GroupCardRow } from "@/components";
import ApplicantDocumentRequests from '../components/Docs/ApplicantDocumentRequests';
import FloatingCommentSection from '@/components/Editors/FloatingCommentSection';
import EditLoanComments from '@/components/Editors/EditLoanComments';
import {mapGetters} from 'vuex';
import EmailAuditLogs from "../components/DataDisplays/EmailAuditLogs.vue";
import CallOutcomeLogs from "../components/DataDisplays/CallOutcomeLogs.vue";

export default {
  components: {
    AuditLogs,
    GroupCard,
    GroupCardRow,
    ApplicantDocumentRequests,
    EditLoanComments,
    FloatingCommentSection,
    EmailAuditLogs,
    CallOutcomeLogs,
  },
  data(){
    return{
      error_dialog: {
        show: false,
        title: '',
        content: '',
      },
      snackbar: {
        show: false,
        icon: "done",
        content: '',
      },
      isEditing: false,
      alertMessage: false,
      message: '',
      loading: false,
    }
  },
  methods:{
    showDialogPopup(title, message) {
      this.error_dialog.title = title;
      this.error_dialog.content = message;
      this.error_dialog.show = true;
    },
    preventNav(event) {
      if (!this.isEditing) return;
      event.preventDefault();
      event.returnValue = '';
    },

    loadmessage(message) {
      this.alertMessage = true;
      this.message = message;
      this.loading = false;
    },

    showErrorDialog(title, message) {
      this.error_dialog.show = true;
      this.error_dialog.title = title;
      this.error_dialog.content = message;
    },

    showSuccessDialog(message) {
      this.snackbar.show = true;
      this.snackbar.icon = "done";
      this.snackbar.content = message;
    },
  },

  computed: {
    ...mapGetters([
      "application",
      'options',
      'user'
    ]),
    style () {
      return 'width: 100%';
    },
    availableSections(){
      return  [
        "Loan",
        "Loan - Owners",
        "Loan - Details",
        "Applicant",
        "Applicant - Personal",
        "Applicant - Personal - Contact Details",
        "Applicant - Personal - Current Address",
        "Applicant - Personal - Credit Report",
        "Applicant - Addresses",
        "Applicant - Addresses - Landlord",
        "Applicant - Addresses - Previous",
        "Applicant - Employment",
        "Applicant - Employment - Current",
        "Applicant - Employment - Previous",
        "Applicant - Employment - Other Incomes",
        "Applicant - Employment - Spouses Details",
        "Applicant - Document Requests",
        "Applicant - Living Expenses",
        "Applicant - Assets & Liabilities",
        "Applicant - References",
        "Wallet Notification"
      ]
    }
  },
}
</script>

<style scoped>
.md-ripple > span {
  position: relative;
}
</style>
